import { Airport } from "shared/types/airportsTypes";

export const internationalData: Airport[] = [
  {
    description: "Amsterdam - Schiphol (AMS), Holanda",
    name: "Amsterdam",
    code: "AMS",
  },
  {
    description: "Barcelona - El Prat (BCN), Espanha",
    name: "Barcelona",
    code: "BCN",
  },
  {
    description: "Bangkok - Suvarnabhumi Intl (BKK), Tailândia",
    name: "Bangkok",
    code: "BKK",
  },
  {
    description: "Berlim - Todos os aeroportos (BER), Alemanha",
    name: "Berlin",
    code: "BER",
  },
  {
    description: "Boston - Logan Intl (BOS), Estados Unidos",
    name: "Boston",
    code: "BOS",
  },
  {
    description: "Budapeste - Ferihegy (BUD), Hungria",
    name: "Budapeste",
    code: "BUD",
  },
  {
    description: "Buenos Aires - Todos os aeroportos (BUE), Argentina",
    name: "Buenos Aires",
    code: "BUE",
  },
  {
    description: "Bruxelas - National (BRU), Bélgica",
    name: "Bruxelas",
    code: "BRU",
  },
  {
    description: "Copenhagen - Copenhagen Airport (CPH), Dinamarca",
    name: "Copenhagen",
    code: "CPH",
  },
  {
    description: "Chicago - Todos os aeroportos (CHI), Estados Unidos",
    name: "Chicago",
    code: "CHI",
  },
  {
    description: "Dubai - Dubai (DXB), Emirados Árabes Unidos",
    name: "Dubai",
    code: "DXB",
  },
  {
    description: "Frankfurt - Frankfurt Intl (FRA), Alemanha",
    name: "Frankfurt",
    code: "FRA",
  },
  {
    description: "Filadelfia - Filadelfia (FLM), Paraguai",
    name: "Filadelfia",
    code: "FLM",
  },
  {
    description: "Glasgow - Glasgow Intl (GGW), Estados Unidos",
    name: "Glasgow",
    code: "GGW",
  },
  {
    description: "Genebra - Geneva Intl (GVA), Suíça",
    name: "Genebra",
    code: "GVA",
  },
  {
    description: "Gênova - Cristoforo Colombo (GOA), Itália",
    name: "Gênova",
    code: "GOA",
  },
  {
    description: "Hanover - Hanover Arpt (HAJ), Alemanha",
    name: "Hannover",
    code: "HAJ",
  },
  {
    description: "Havana - Jose Marti Intl (HAV), Cuba",
    name: "Havana",
    code: "HAV",
  },
  {
    description: "Hong Kong - Hong Kong Intl (HKG), Hong Kong",
    name: "Hong Kong",
    code: "HKG",
  },
  {
    description: "Istambul - Sabiha Gokcen (SAW), Turquia",
    name: "IstambuL",
    code: "SAW",
  },
  {
    description: "Joanesburgo - Intl (JNB), África do Sul",
    name: "Johanesburg",
    code: "JNB",
  },
  {
    description: "La Paz - El Alto (LPB), Bolívia",
    name: "La Paz",
    code: "LPB",
  },
  {
    description: "Las Vegas - McCarran Intl (LAS), Estados Unidos",
    name: "Las Vegas",
    code: "LAS",
  },
  {
    description: "Lima - Jorge Chávez (LIM), Peru",
    name: "Lima",
    code: "LIM",
  },
  {
    description: "Lisboa - Lisboa (LIS), Portugal",
    name: "Lisboa",
    code: "LIS",
  },
  {
    description: "London - Todos os aeroportos (LON), Reino Unido",
    name: "Londres",
    code: "LON",
  },
  {
    description: "Los Angeles - Los Angeles Intl (LAX), Estados Unidos",
    name: "Los Angeles",
    code: "LAX",
  },
  {
    description: "Madri - Barajas (MAD), Espanha",
    name: "Madri",
    code: "MAD",
  },
  {
    description: "Cidade do México - Juarez Intl (MEX), México",
    name: "Mexico City",
    code: "MEX",
  },
  {
    description: "Miami - Miami Intl (MIA), Estados Unidos",
    name: "Miami",
    code: "MIA",
  },
  {
    description: "Milan - Todos os aeroportos (MIL), Itália",
    name: "Milão",
    code: "MIL",
  },
  {
    description: "Montevideo - Carrasco (MVD), Uruguai",
    name: "Montevideo",
    code: "MVD",
  },
  {
    description: "Montreal - Todos os aeroportos (YMQ), Canadá",
    name: "Montreal",
    code: "YMQ",
  },
  {
    description: "Moscou - Bandundu (VKO), Rússia",
    name: "Moscou",
    code: "VKO",
  },
  {
    description: "Munich - Franz J Strauss (MUC), Alemanha",
    name: "Munique",
    code: "MUC",
  },
  {
    description: "New York - Todos os aeroportos (NYC), Estados Unidos",
    name: "Nova York",
    code: "NYC",
  },
  {
    description: "Orlando - Todos os aeroportos (ORL), Estados Unidos",
    name: "Orlando",
    code: "ORL",
  },
  {
    description: "Panama City - London Ashford (PTY), Panamá",
    name: "Panama City",
    code: "PTY",
  },
  {
    description: "Paris - Todos os aeroportos (PAR), França",
    name: "Paris",
    code: "PAR",
  },
  {
    description: "Roma - Todos os aeroportos (ROM), Itália",
    name: "Roma",
    code: "ROM",
  },
  {
    description: "São Francisco - San Francisco Intl (SFO), Estados Unidos",
    name: "San Francisco",
    code: "SFO",
  },
  {
    description: "Santiago do Chile - A Merino Benitez (SCL), Chile",
    name: "Santiago do Chile",
    code: "SCL",
  },
  {
    description: "Shanghai - Hongqiao Intl (SHA), China",
    name: "Shangai",
    code: "SHA",
  },
  {
    description: "Singapura - Changi (SIN), Singapura",
    name: "Singapura",
    code: "SIN",
  },
  {
    description: "Toronto - Todos os aeroportos (YTO), Canadá",
    name: "Toronto",
    code: "YTO",
  },
  {
    description: "Tokyo - Todos os aeroportos (TYO), Japão",
    name: "Tokio",
    code: "TYO",
  },
  {
    description: "Washington - Todos os aeroportos (WAS), Estados Unidos",
    name: "Washington",
    code: "WAS",
  },
  {
    description: "Zurich - Zurich (ZRH), Suíça",
    name: "Zurique",
    code: "ZRH",
  },
];
